<template>
  <Layout>
    <div class="row">
      <div class="col-sm-12 col-xl-3 col-lg-4 pb-30 scrollable-left">
        <ul
          class="nav nav-pills mb-3 nav-fill leftTabMenu"
          id="pills-tab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="pills-calendar-tab"
              data-toggle="pill"
              href="#pills-calendar"
              role="tab"
              aria-controls="pills-calendar"
              aria-selected="true"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 28.5V10.5H32.25V28.5C32.25 30.15 30.9 31.5 29.25 31.5H6.75C5.1 31.5 3.75 30.15 3.75 28.5Z"
                  fill="#CFD8DC"
                />
                <path
                  d="M32.25 7.5V12H3.75V7.5C3.75 5.85 5.1 4.5 6.75 4.5H29.25C30.9 4.5 32.25 5.85 32.25 7.5Z"
                  fill="#71A2FF"
                />
                <path
                  d="M24.75 9.75C25.9926 9.75 27 8.74264 27 7.5C27 6.25736 25.9926 5.25 24.75 5.25C23.5074 5.25 22.5 6.25736 22.5 7.5C22.5 8.74264 23.5074 9.75 24.75 9.75Z"
                  fill="#436EC2"
                />
                <path
                  d="M11.25 9.75C12.4926 9.75 13.5 8.74264 13.5 7.5C13.5 6.25736 12.4926 5.25 11.25 5.25C10.0074 5.25 9 6.25736 9 7.5C9 8.74264 10.0074 9.75 11.25 9.75Z"
                  fill="#436EC2"
                />
                <path
                  d="M24.75 2.25C23.925 2.25 23.25 2.925 23.25 3.75V7.5C23.25 8.325 23.925 9 24.75 9C25.575 9 26.25 8.325 26.25 7.5V3.75C26.25 2.925 25.575 2.25 24.75 2.25Z"
                  fill="#B0BEC5"
                />
                <path
                  d="M11.25 2.25C10.425 2.25 9.75 2.925 9.75 3.75V7.5C9.75 8.325 10.425 9 11.25 9C12.075 9 12.75 8.325 12.75 7.5V3.75C12.75 2.925 12.075 2.25 11.25 2.25Z"
                  fill="#B0BEC5"
                />
                <path d="M9.75 15H12.75V18H9.75V15Z" fill="#90A4AE" />
                <path d="M14.25 15H17.25V18H14.25V15Z" fill="#90A4AE" />
                <path d="M18.75 15H21.75V18H18.75V15Z" fill="#90A4AE" />
                <path d="M23.25 15H26.25V18H23.25V15Z" fill="#90A4AE" />
                <path d="M9.75 19.5H12.75V22.5H9.75V19.5Z" fill="#90A4AE" />
                <path d="M14.25 19.5H17.25V22.5H14.25V19.5Z" fill="#90A4AE" />
                <path d="M18.75 19.5H21.75V22.5H18.75V19.5Z" fill="#90A4AE" />
                <path d="M23.25 19.5H26.25V22.5H23.25V19.5Z" fill="#90A4AE" />
                <path d="M9.75 24H12.75V27H9.75V24Z" fill="#90A4AE" />
                <path d="M14.25 24H17.25V27H14.25V24Z" fill="#90A4AE" />
                <path d="M18.75 24H21.75V27H18.75V24Z" fill="#90A4AE" />
                <path d="M23.25 24H26.25V27H23.25V24Z" fill="#90A4AE" />
              </svg>
              TAKVİM</a
            >
          </li>
          <!-- <li class="nav-item" role="presentation">
                      <a
                        class="nav-link "
                        id="pills-statistic-tab"
                        data-toggle="pill"
                        href="#pills-statistic"
                        role="tab"
                        aria-controls="pills-statistic"
                        aria-selected="false"
                        >İSTATİSTİKLER</a
                      >
                    </li> -->
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-calendar"
            role="tabpanel"
            aria-labelledby="pills-calendar-tab"
          >
            <LessonCalendar
              class="w-100"
              :calendarEvents="calendarEvents"
            ></LessonCalendar>
            <hr class="my-30" />
            <h4 class="secondary-title mb-3">
              Yaklaşan <span class="fw-bold">Etkinlikler</span>
            </h4>
            <ul
              class="nav nav-pills mb-3 nav-fill calendarTabMenu mb-30"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="pills-calendarAll-tab"
                  data-toggle="pill"
                  href="#pills-calendarAll"
                  role="tab"
                  aria-controls="pills-calendarAll"
                  aria-selected="true"
                  >Tümü</a
                >
              </li>
              <!-- <li class="nav-item" role="presentation">
                              <a
                                class="nav-link disabled"
                                disabled
                                id="pills-calendarLesson-tab"
                                data-toggle="pill"
                                href="#pills-calendarLesson"
                                role="tab"
                                aria-controls="pills-calendarLesson"
                                aria-selected="false"
                                >Dersler</a
                              >
                            </li> -->
              <li class="nav-item" role="presentation">
                <router-link
                  :to="{ name: 'exam_list' }"
                  class="nav-link"
                  id="pills-calendarExam-tab"
                  data-toggle="pill"
                  aria-controls="pills-calendarExam"
                  aria-selected="false"
                  >Sınavlar
                </router-link>
              </li>
            </ul>
            <div class="tab-content" id="pills-calendarTabContent">
              <div
                class="tab-pane fade show active"
                id="pills-calendarAll"
                role="tabpanel"
                aria-labelledby="pills-calendarAll-tab"
              >
                <div class="limited-box-wrapper">
                  <div
                    class="limited-box d-flex align-items-center justify-content-center"
                    v-if="!Object.keys(calendarEvents).length"
                  >
                    <div
                      class="d-flex flex-column align-items-center w-75 mx-auto"
                    >
                      <img
                        src="@/assets/img/not-found-lesson.svg"
                        alt=""
                        class="w-100"
                        style="opacity:0.8"
                      />
                      <p class="fw-600 mt-30 text-muted">
                        Yaklaşan bir etkinlik bulunmuyor.
                      </p>
                    </div>
                  </div>
                  <div class="limited-box" v-else>
                    <div
                      class="d-flex flex-column"
                      v-for="(eventList, index) in calendarEvents"
                      :key="'event' + index"
                    >
                      <CalendarEventCard
                        v-for="(item, index) in eventList"
                        :key="'item' + index"
                        :calendarEvent="item"
                        calendarEventType="ders"
                        :class="index !== eventList.length - 1 ? 'mb-25' : ''"
                      />
                      <hr class="my-35" />
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="pills-calendarLesson"
                role="tabpanel"
                aria-labelledby="pills-calendarLesson-tab"
              ></div>
              <div
                class="tab-pane fade"
                id="pills-calendarExam"
                role="tabpanel"
                aria-labelledby="pills-calendarExam-tab"
              ></div>
            </div>
          </div>
          <div
            class="tab-pane fade "
            id="pills-statistic"
            role="tabpanel"
            aria-labelledby="pills-statistic-tab"
          >
            <CustomSelectBox
              :options="['Çözülmüş Testler', 'Bu Hafta ', 'Bu Ay']"
              :default="'Çözülmüş Testler'"
              class="select"
            />

            <ChartQuiz
              style=""
              class="mr-auto quiz-chart"
              :chartOption="chartOption"
            />
          </div>
        </div>
        <hr class="my-40" v-if="sectionEnabled.lastVideos" />

        <div class="" v-if="sectionEnabled.lastVideos">
          <h4 class="secondary-title ">
            İzlenen <span class="fw-bold">Son Eğitimler</span>
            <span class="badge badge-feature badge-info">yakında</span>
          </h4>
          <div>
            <LessonProgressSwiper></LessonProgressSwiper>
          </div>
        </div>

        <hr class="my-40" v-if="sectionEnabled.lastVideos" />

        <div class="" v-if="sectionEnabled.lastExams">
          <h4 class="secondary-title ">
            Çözdüğün <span class="fw-bold">Son Sınavlar</span>
          </h4>
          <div>
            <ExamsSwiper></ExamsSwiper>
          </div>
        </div>
        <hr class="my-40" v-if="sectionEnabled.lastExams" />

        <div class="" v-if="sectionEnabled.lastParagraphs">
          <h4 class="secondary-title ">
            Okunan <span class="fw-bold">Son Paragraflar</span>
          </h4>
          <div>
            <ParagraphSwiper />
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-xl-9 col-lg-8 pl-40 p-mobile-10 scrollable-right "
      >
        <p class="primary-title ">
          Sık <span class="text-primary">Kullanılanlar</span>
        </p>

        <div class="favorite-grid my-30">
          <router-link
            :to="{
              name: 'lesson_list',
              params: { tab: 'online' },
            }"
            class="favorite"
          >
            <img src="../assets/img/favorite-1.svg" alt="" />
            <span class="h6 text-muted mb-0">Canlı ve Kayıttan</span>
            <span class="favorite-text">Online Eğitimler</span>
          </router-link>
          <router-link
            :to="{
              name: 'lesson_list',
              params: { tab: 'offline' },
            }"
            class="favorite"
          >
            <img src="../assets/img/favorite-2.svg" alt="" />
            <span class="h6 text-muted mb-0">Canlı Ders Kayıtları</span>
            <span class="favorite-text">Offline Eğitimler</span>
          </router-link>
          <router-link
            :to="{
              name: 'lesson_list',
              params: { tab: 'video' },
            }"
            class="favorite"
          >
            <img src="../assets/img/favorite-3.svg" alt="" />
            <span class="h6 text-muted mb-0">Tamamlanmış Eğitimler</span>
            <span class="favorite-text">Video Dersler</span>
          </router-link>
          <router-link
            :to="{ name: 'lesson_detail', params: { id: 106 } }"
            class="favorite"
          >
            <img src="../assets/img/favorite-5.svg" alt="" />
            <span class="h6 text-muted mb-0">Ek Ders Kayıtları</span>
            <span class="favorite-text">Online Ek Dersler</span>
          </router-link>
          <a
            class="favorite"
            :href="this.$root.getWebSiteURL() + '/ucretsiz-yds-yokdil-kaynaklari'"
          >
            <img src="../assets/img/favorite-4.svg" alt="" />
            <span class="h6 text-muted mb-0">Denemeler, Konu Taramalar</span>
            <span class="favorite-text">Sınavlar & Testler</span>
          </a>
        </div>

        <HomeSbSwiper :sliderData="sliderData" />

        <div class="py-30" v-if="lastLectures != null">
          <p class="primary-title mb-3">
            Son Eklenen <span class="text-primary">Derslerim</span>
          </p>
          <div>
            <div class="row">
              <div
                class="col-lg-6 col-xl-4 mb-3"
                v-for="(lecture, index) in lastLectures"
                :key="index"
              >
                <VideoCard :lecture="lecture"></VideoCard>
              </div>
            </div>
          </div>
        </div>

        <div class="row py-30">
          <div class="col-md-12">
            <p class="primary-title mb-10 text-primary">
              Haftanın <span class="">Paragrafı</span>
            </p>
            <DailyParagraph :paragraph="paragraph" />
          </div>
        </div>

        <div class="row ">
          <div class="col-md-12 mb-3">
            <p class="primary-title mb-10 text-primary">
              Kelime <span class="">Kartları</span>
            </p>
          </div>

          <div
            class="col-md-6 mb-5"
            v-for="(word, index) of words"
            :key="'word' + index"
          >
            <DailyWord :word="word" class="mb-10" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/Layout.vue';
import ChartQuiz from '../components/ChartQuiz.vue';
import LessonProgressSwiper from '../components/LessonProgressSwiper.vue';
import ExamsSwiper from '../components/ExamsSwiper.vue';
import LessonCalendar from '../components/LessonCalendar.vue';
import VideoCard from '../components/VideoCard.vue';
import DailyParagraph from '../components/DailyParagraph.vue';
import DailyWord from '../components/DailyWord.vue';
import CalendarEventCard from '../components/CalendarEventCard.vue';
import ParagraphSwiper from '../components/ParagraphSwiper.vue';
import CustomSelectBox from '../components/CustomSelectBox.vue';
import HomeSbSwiper from '../components/HomeSbSwiper.vue';

export default {
  name: 'Home',
  components: {
    Layout,
    ChartQuiz,
    LessonProgressSwiper,
    ExamsSwiper,
    LessonCalendar,
    VideoCard,
    DailyParagraph,
    DailyWord,
    CalendarEventCard,
    ParagraphSwiper,
    CustomSelectBox,
    HomeSbSwiper,
  },

  data() {
    return {
      sectionEnabled: {
        lastVideos: false,
        lastParagraphs: false,
        lastExams: false,
      },
      paragraph: {
        translate: {
          title: 'Desertificationa',
        },
        image: {
          public_url:
            'https://media.nature.com/lw800/magazine-assets/d41586-019-01448-4/d41586-019-01448-4_16691160.jpg',
        },
      },
      lastLectures: [],
      calendarEvents: [],
      sliderData: [],
      // paragraph: {
      //   title: 'One million species face extinction',
      //   image:
      //     'https://media.nature.com/lw800/magazine-assets/d41586-019-01448-4/d41586-019-01448-4_16691160.jpg',
      //   text:
      //     '<img class="w-100 mb-3" src="https://media.nature.com/lw800/magazine-assets/d41586-019-01448-4/d41586-019-01448-4_16691160.jpg"><p>Up to one million plant and animal species face extinction, many within decades, because of human activities, says the most comprehensive report yet on the state of global ecosystems.</p><p>The rate of species extinctions is already tens to hundreds of times higher than the average across the past ten million years. Without dras-tic action to conserve habitats, the extinction rate will only increase, says a United Nations-backed panel called the Intergovernmental Science-Policy Platform on Biodiversity and Ecosystem Services (IPBES).</p><p>About 75% of land and 66% of ocean areas have been “significantly altered” by people, driven in large part by agriculture, according to a summary of the work, released on 6 May (see go.nature.com/2v4zbn9). The loss of spe-cies and habitats poses as much a danger to life on Earth as climate change does, the IPBES report says.</p><p>The analysis distils findings from nearly 15,000 studies and government reports, integrating information from the natural and social sciences, Indigenous peoples and traditional agricultural communities. The report is the first major international appraisal of biodiversity since 2005. Repre-sentatives of 132 governments met last week in Paris to finalize and approve it.</p><p>“We  have  never  had  a  single  unified  statement from the world’s governments that unambiguously makes clear the crisis we are facing for life on Earth,” says Thomas Brooks, chief scientist at the International Union for Conservation of Nature in Gland, Switzerland, who helped to edit the report. “That is really the absolutely key novelty that we see here.”</p><p>Without “transformative changes” to the world’s economic, social and political systems to address this crisis, the IPBES panel projects that major biodiversity losses will continue to 2050 and beyond. </p><p>The analysis, which will be released in full later this year, also inextricably links biodiver-sity loss and climate change. An estimated 5% of all species would be threatened with extinction by 2 °C of warming above pre-industrial levels — a threshold that the world could breach in the next few decades, unless greenhouse-gas emis-sions are drastically reduced. </p><p>The biodiversity crisis should be at the top of the global agenda alongside climate, said Anne Larigauderie, IPBES executive secretary, at a 6 May press conference in Paris. “We can no longer say that we did not know,” she said. </p>',
      // },

      words: [
        {
          text: 'GO THROUGH',
          definition: 'to experience a difficult or unpleasant situation',
          meaning: 'zor zaman geçirmek, güçlük yaşamak',
          synonymus: [
            'experience',
            'face',
            'undergo',
            'be exposed to',
            'be subject to',
          ],
          examples: [
            {
              text:
                'We can’t really imagine what refugees are <b>going through</b>  in a foreign country',
              mean: '',
            },
            {
              text: 'Caterpillars <b>go through</b> several stages of growth.',
              mean: '',
            },
            {
              text:
                'She is <b>going through</b> a difficult time with her job.',
              mean: '',
            },
          ],
          sound:
            'https://freesound.org/data/previews/150/150222_2712074-lq.mp3',
        },
        {
          text: 'FOSTER',
          definition:
            'to help a skill, feeling, idea etc develop over a period of time',
          meaning: '(fikir, durum, his) gelişmesine yardımcı olmak',

          synonymus: ['promote', 'support', 'advance', 'encourage'],
          examples: [
            {
              text:
                'This approach will <b>foster</b> an understanding of environmental issues.',
              mean: '',
            },
            {
              text:
                'Recent studies show that advertising usually <b>fosters</b> competition and therefore lower prices.',
              mean: '',
            },
            {
              text:
                'The growth of the Internet could <b>foster</b> economic development worldwide.',
              mean: '',
            },
          ],
          sound:
            'https://freesound.org/data/previews/150/150222_2712074-lq.mp3',
        },
        {
          text: 'MASSIVE',
          definition: ' very large, solid, and heavy',
          meaning: 'muazzam, çok büyük, muhteşem',

          synonymus: ['colossal', 'enormous', 'grand', 'immense', 'monumental'],
          examples: [
            {
              text:
                'A black hole typically arises from the death of a <b>massive</b> star.',
              mean: '',
            },
            {
              text:
                'The system is capable of recording <b>massive</b> amounts of information.',
              mean: '',
            },
            {
              text:
                'We have seen a <b>massive</b> change in the social structure and interactions of populations since the start of the pandemic.',
              mean: '',
            },
          ],
          sound:
            'https://freesound.org/data/previews/150/150222_2712074-lq.mp3',
        },
        {
          text: 'PROSPECT',
          definition: ' the possibility that something will happen',
          meaning: 'olasılık, ihtimal, imkân, umut',

          synonymus: ['chance', 'likelihood', 'promise'],
          examples: [
            {
              text:
                'Doctors say there is little <b>prospect</b> of any improvement in his condition',
              mean: '',
            },
            {
              text:
                '<b>Prospects</b> for a peace settlement in the region are not very hopeful at the moment.',
              mean: '',
            },
            {
              text:
                'There is a reasonable <b>prospect</b> that his debts will be paid.',
              mean: '',
            },
          ],
          sound:
            'https://freesound.org/data/previews/150/150222_2712074-lq.mp3',
        },
      ],

      calendarEvent: {
        title: 'Koç Grubu YDS İlkbahar 2021',
        teacher: 'Ahmet AKIN',
        description: 'Ders: 02 Temel Sözcük Dizimi',
        date: '19 Aralık 2021 19:30',
      },
      calendarEventType: 'deneme',

      chartOption: {
        title: {
          text:
            '<span style="font-size: 14px;font-weight:bold">Çözülmüş Testler</span>',
          fontSize: '12',
        },
        chart: {
          type: 'column',
          backgroundColor: 'transparent',
        },

        xAxis: {
          categories: ['Pzt', 'Salı', 'Çrş', 'Prş', 'Cum', 'Cts', 'Pzr'],
          labels: {
            style: {
              fontSize: '16px',
              fontWeight: 'bold',
            },
          },
        },
        plotOptions: {
          backgroundColor: '#3271e6',
          column: {
            pointWidth: '15',
          },
        },
        tooltip: {
          pointFormat:
            '<span style="font-weight: bold; color: {series.color}">{series.name}</span>: <b>{point.y:.1f} puan</b> ',
        },
        series: [
          {
            name: 'Puanlar',
            data: [5, 3, 4, 7, 120, 8, 75],
            color: '#3271e6',
            width: '30px',
            stack: 'male',
          },
        ],
      },
    };
  },

  created() {
    this.fetchLessonLastLectures();
    this.fetchCalendarEvents();
    this.fetchSlider();
    this.fetchDailyParagraph();
  },
  methods: {
    fetchLessonLastLectures() {
      this.axios.get('/lesson/lecture/last?limit=3').then((response) => {
        this.lastLectures = response.data.data;
      });
    },

    fetchSlider() {
      this.axios
        .get('/module/slider?alias=client_main_slider')
        .then(({ data }) => {
          this.sliderData = data.data;
        });
    },

    fetchCalendarEvents() {
      this.axios
        .get('/lesson/event-calendar?include_expire_today=1')
        .then(({ data }) => {
          this.calendarEvents = data.data;
        });
    },
    fetchDailyParagraph() {
      this.axios
        .get('/module/paragraph/daily?language_id=2')
        .then(({ data }) => {
          this.paragraph = data.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.magaza-intro {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__ico {
    min-width: 65px;
    max-width: 65px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: rgba(white, 0.1);
    border-radius: 16px;
  }
}

.pulseSmall {
  animation: pulseSmall 1.5s infinite;
}
</style>
